import { render } from "./ProjectContextModal.vue?vue&type=template&id=b242ca30"
import script from "./ProjectContextModal.vue?vue&type=script&lang=js"
export * from "./ProjectContextModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__